<template>
  <div class="mb-3">
    <div class="section-title mb-4">Sản phẩm</div>
    <b-tabs v-model="activeTab" content-class="mt-4">
      <b-tab title="Sản phẩm khách muốn sở hữu">
        <b-row>
          <b-col md="12">
            <Treeselect
              :value="targetValue"
              :load-options="onSearchTargetProduct"
              :default-options="targetDefaultOptions"
              :multiple="false"
              :async="true"
              :placeholder="'Tìm sản phẩm (tên, mã...)'"
              :cache-options="true"
              :clearable="true"
              :disabled="isView"
              retryText="Thử lại..."
              retryTitle="Nhấp thử lại"
              searchPromptText="Nhập để tìm kiếm..."
              loadingText="Đang tải..."
              noResultsText="Không có kết quả"
              openDirection="bottom"
              @select="onSelectTargetProduct"
              @input="onTargetInput"
            >
              <label
                slot="option-label"
                slot-scope="{ node, labelClassName }"
                :class="labelClassName"
              >
                <div>
                  <template v-if="node.raw">
                    <b class="text-primary">
                      ( {{ convertPrice(node.raw.sellingPrice) }} )
                    </b>
                    <b
                      :class="
                        (node.raw.quantityInStock || 0) > 0
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      ( TCB:{{ node.raw.quantityInStock || 0 }} )
                    </b>
                    {{ node.raw.name || node.raw.label }}
                  </template>
                  <template v-else>{{ node.label }}</template>
                </div>
              </label>
            </Treeselect>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="6">
            <b-form-group label="Tên sản phẩm" label-for="targetProductName">
              <b-form-input
                id="targetProductName"
                v-model.trim="localForm.targetProductName"
                :disabled="isView"
                placeholder="Tên sản phẩm"
                @input="emitUpdate('targetProductName', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Giá bán dự kiến (VND)"
              label-for="targetQuotedPrice"
            >
              <b-form-input
                id="targetQuotedPrice"
                type="text"
                :value="targetQuotedPriceDisplay"
                :disabled="isView"
                placeholder="0"
                @input="onTargetQuotedPriceInput($event)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="targetSummary" class="mt-4">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th class="header-color text-center">Sản phẩm</th>
                <th class="header-color text-center">Mã sản phẩm</th>
                <th class="header-color text-center">Giá bán dự kiến</th>
                <th
                  class="header-color text-center"
                  v-if="!isView"
                  style="width: 64px"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p class="m-0 font-weight-bolder">
                    {{ targetSummary.name || 'N/A' }}
                  </p>
                </td>
                <td class="text-center">
                  <span class="font-weight-bolder">
                    {{ targetSummary.code || 'N/A' }}
                  </span>
                </td>
                <td class="text-right">
                  <b class="text-primary">
                    {{
                      targetSummary.price != null
                        ? convertPrice(targetSummary.price)
                        : 'N/A'
                    }}
                  </b>
                </td>
                <td v-if="!isView" class="text-center">
                  <b-button
                    size="sm"
                    variant="danger"
                    class="btn btn-icon"
                    title="Xóa"
                    @click="clearTarget"
                  >
                    <i class="fas fa-trash"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

      <b-tab title="Sản phẩm thu cũ">
        <b-row>
          <b-col md="12">
            <Treeselect
              :value="tradeinValue"
              :load-options="onSearchTradeinProduct"
              :default-options="tradeinDefaultOptions"
              :multiple="false"
              :async="true"
              :placeholder="'Tìm xe thu cũ (tên, mã...)'"
              :cache-options="true"
              :clearable="true"
              :disabled="isView"
              retryText="Thử lại..."
              retryTitle="Nhấp thử lại"
              searchPromptText="Nhập để tìm kiếm..."
              loadingText="Đang tải..."
              noResultsText="Không có kết quả"
              openDirection="bottom"
              @select="onSelectTradeinProduct"
              @input="onTradeinInput"
            >
              <label
                slot="option-label"
                slot-scope="{ node, labelClassName }"
                :class="labelClassName"
              >
                <div>
                  <template v-if="node.raw">
                    <b class="text-primary">
                      ( {{ convertPrice(node.raw.sellingPrice) }} )
                    </b>
                    <b
                      :class="
                        (node.raw.quantityInStock || 0) > 0
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      ( TCB:{{ node.raw.quantityInStock || 0 }} )
                    </b>
                    {{ node.raw.name || node.raw.label }}
                  </template>
                  <template v-else>{{ node.label }}</template>
                </div>
              </label>
            </Treeselect>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="6">
            <b-form-group
              label="Tên xe/phiên bản"
              label-for="tradeinProductName"
            >
              <b-form-input
                id="tradeinProductName"
                v-model.trim="localForm.tradeinProductName"
                :disabled="isView"
                placeholder="Tên xe/phiên bản"
                @input="emitUpdate('tradeinProductName', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Giá thu dự kiến (VND)"
              label-for="tradeinEstimationPrice"
            >
              <b-form-input
                id="tradeinEstimationPrice"
                type="text"
                :value="tradeinEstimationPriceDisplay"
                :disabled="isView"
                placeholder="0"
                @input="onTradeinEstimationPriceInput($event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Số khung" label-for="tradeinChassisNumber">
              <template #label
                >Số khung <span class="text-danger">*</span></template
              >
              <b-form-input
                id="tradeinChassisNumber"
                v-model.trim="localForm.tradeinChassisNumber"
                :disabled="isView"
                placeholder="Nhập số khung"
                @input="emitUpdate('tradeinChassisNumber', $event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Số máy" label-for="tradeinEngineNumber">
              <b-form-input
                id="tradeinEngineNumber"
                v-model.trim="localForm.tradeinEngineNumber"
                :disabled="isView"
                placeholder="Nhập số máy"
                @input="emitUpdate('tradeinEngineNumber', $event)"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="tradeinSummary" class="mt-4">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th class="header-color text-center">Sản phẩm</th>
                <th class="header-color text-center">Mã sản phẩm</th>
                <th class="header-color text-center">Giá thu dự kiến</th>
                <th
                  class="header-color text-center"
                  v-if="!isView"
                  style="width: 64px"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p class="m-0 font-weight-bolder">
                    {{ tradeinSummary.name || 'N/A' }}
                  </p>
                </td>
                <td class="text-center">
                  <span class="font-weight-bolder">
                    {{ tradeinSummary.code || 'N/A' }}
                  </span>
                </td>
                <td class="text-right">
                  <b class="text-primary">
                    {{
                      tradeinSummary.price != null
                        ? convertPrice(tradeinSummary.price)
                        : 'N/A'
                    }}
                  </b>
                </td>
                <td v-if="!isView" class="text-center">
                  <b-button
                    size="sm"
                    variant="danger"
                    class="btn btn-icon"
                    title="Xóa"
                    @click="clearTradein"
                  >
                    <i class="fas fa-trash"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <b-row class="mt-3">
          <b-col md="12">
            <b-form-group label="Hình ảnh xe thu cũ">
              <div
                class="d-flex flex-wrap align-items-start gap-3 image-gallery"
              >
                <div
                  v-for="(path, i) in imageUrls"
                  :key="'img-' + i"
                  class="image-preview-wrapper position-relative mr-3 mb-3"
                >
                  <b-img
                    v-if="getPreviewUrl(path)"
                    :src="getPreviewUrl(path)"
                    thumbnail
                    fluid
                    class="image-preview"
                    alt="Ảnh thu cũ"
                    @click="openImageUrl(path)"
                  />
                  <div
                    v-else
                    class="image-preview image-preview-placeholder d-flex align-items-center justify-content-center"
                  >
                    <b-spinner size="sm" variant="secondary"></b-spinner>
                  </div>
                  <b-button
                    v-if="!isView"
                    variant="danger"
                    class="btn-icon rounded-circle remove-btn p-0"
                    title="Xóa ảnh"
                    @click.stop="removeImage(i)"
                  >
                    <i class="fas fa-times"></i>
                  </b-button>
                </div>

                <div
                  v-if="!isView"
                  class="upload-trigger-box d-flex flex-column align-items-center justify-content-center text-muted mr-3 mb-3 cursor-pointer position-relative"
                  @click="!uploading ? $refs.fileInput.click() : null"
                >
                  <template v-if="!uploading">
                    <i
                      class="fas fa-cloud-upload-alt mb-2"
                      style="font-size: 24px"
                    ></i>
                    <span class="font-weight-bold" style="font-size: 13px"
                      >Thêm ảnh</span
                    >
                  </template>
                  <template v-else>
                    <b-spinner
                      size="sm"
                      variant="primary"
                      class="mb-2"
                    ></b-spinner>
                    <span style="font-size: 12px">Đang tải...</span>
                  </template>
                </div>
              </div>

              <input
                v-if="!isView"
                ref="fileInput"
                type="file"
                accept="image/jpeg, image/png, image/webp"
                multiple
                class="d-none"
                @change="onFileChange"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { convertPrice } from '@/utils/common';

import productService from '@/core/api/product';
import { ProductModel } from '@/core/models';
import PreorderService from '@/core/api/preorder/preorder.service';

import * as ENUM from '@/utils/enum';

export default {
  name: 'ProductsSection',
  components: {
    Treeselect,
  },
  props: {
    form: { type: Object, required: true },
    mode: { type: [String, Number], default: ENUM.MODE.ADD },
  },
  data() {
    return {
      MODE: ENUM.MODE,
      activeTab: 0,

      localForm: {},
      initialTabSynced: false,

      // treeselect options
      targetProductOptions: [],
      tradeinProductOptions: [],

      uploading: false,
      previewBlobUrls: {},
    };
  },
  computed: {
    isView() {
      return this.mode === this.MODE.VIEW;
    },
    formKey() {
      const id = this.form?.id ?? '';
      const type = this.form?.type ?? '';
      return `${id}|${type}`;
    },
    targetValue() {
      return (
        this.localForm.targetProductId ?? this.form.targetProductId ?? null
      );
    },
    tradeinValue() {
      const attrs =
        this.localForm.tradeinAttributes || this.form.tradeinAttributes || {};
      return attrs.tradeinProductId ?? null;
    },
    imageUrls() {
      const attrs =
        this.localForm.tradeinAttributes || this.form?.tradeinAttributes || {};
      const imgs = attrs?.images;
      return Array.isArray(imgs) ? imgs : [];
    },
    targetSummary() {
      const name =
        this.localForm.targetProductName || this.form.targetProductName;
      const id = this.localForm.targetProductId ?? this.form.targetProductId;
      if (!name && !id) return null;

      const p = this.form.targetProduct || null;
      const code = p?.code || null;
      const price =
        this.localForm.targetQuotedPrice ??
        this.form.targetQuotedPrice ??
        p?.sellingPrice ??
        null;
      return { id, name, code, price };
    },
    targetQuotedPriceDisplay() {
      const v = this.localForm.targetQuotedPrice ?? this.form.targetQuotedPrice;
      if (v == null || v === '') return '';
      return this.convertPrice(Number(v));
    },
    tradeinEstimationPriceDisplay() {
      const v =
        this.localForm.tradeinEstimationPrice ??
        this.form.tradeinEstimationPrice;
      if (v == null || v === '') return '';
      return this.convertPrice(Number(v));
    },
    tradeinSummary() {
      const name =
        this.localForm.tradeinProductName || this.form.tradeinProductName;
      const chassis =
        this.localForm.tradeinChassisNumber || this.form.tradeinChassisNumber;
      const engine =
        this.localForm.tradeinEngineNumber || this.form.tradeinEngineNumber;
      const price =
        this.localForm.tradeinEstimationPrice ??
        this.form.tradeinEstimationPrice ??
        null;
      const code =
        this.localForm.tradeinAttributes?.tradeinProductCode ||
        this.form.tradeinAttributes?.tradeinProductCode ||
        'N/A';

      if (
        !name &&
        !chassis &&
        !engine &&
        price == null &&
        !this.imageUrls.length
      )
        return null;
      return { name, chassis, engine, price, code };
    },
    // Default options để Treeselect hiển thị đúng label khi đã có value (edit mode)
    targetDefaultOptions() {
      const id = this.targetValue ?? this.form?.targetProductId;
      if (!id) return [];
      const name =
        this.localForm.targetProductName ||
        this.form?.targetProductName ||
        this.form?.targetProduct?.name;
      if (!name) return [];
      const p = this.form?.targetProduct || {};
      return [
        {
          id,
          label: name,
          name,
          sellingPrice: p.sellingPrice,
          code: p.code,
          quantityInStock: p.quantityInStock ?? 0,
        },
      ];
    },
    tradeinDefaultOptions() {
      const attrs =
        this.localForm.tradeinAttributes || this.form?.tradeinAttributes || {};
      const id = attrs.tradeinProductId ?? null;
      if (!id) return [];
      const name =
        this.localForm.tradeinProductName ||
        this.form?.tradeinProductName ||
        this.form?.tradeinProduct?.name;
      if (!name) return [];
      const p = this.form?.tradeinProduct || {};
      return [
        {
          id,
          label: name,
          name,
          sellingPrice: p.sellingPrice,
          code: p.code,
          quantityInStock: p.quantityInStock ?? 0,
        },
      ];
    },
  },
  watch: {
    // Sync parent form into localForm. We only assign to localForm (no emit here) to avoid
    // reactivity loops. For future hardening, consider watching specific keys (e.g. formKey +
    // form.storeId, form.targetProductId) and syncing only on record switch.
    form: {
      immediate: true,
      deep: true,
      handler(v) {
        this.localForm = { ...this.localForm, ...(v || {}) };
        if (!this.initialTabSynced) {
          this.$nextTick(() => {
            this.syncInitialTab();
            this.initialTabSynced = true;
          });
        }
      },
    },
    formKey() {
      // switching between records or changing type should re-evaluate initial tab
      this.initialTabSynced = false;
      this.$nextTick(() => {
        this.syncInitialTab();
        this.initialTabSynced = true;
      });
    },
    imageUrls: {
      handler(paths) {
        this.loadPreviewBlobUrls(paths || []);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    Object.values(this.previewBlobUrls || {}).forEach((url) => {
      if (url && typeof url === 'string') URL.revokeObjectURL(url);
    });
  },
  methods: {
    convertPrice,

    emitUpdate(field, value) {
      this.$emit('update-field', { field, value });
    },

    onTargetQuotedPriceInput(e) {
      const raw = (e && e.target ? e.target.value : e) ?? '';
      const digitsOnly = String(raw).replace(/[^\d]/g, '');
      const num = digitsOnly === '' ? null : Number(digitsOnly);
      this.emitUpdate('targetQuotedPrice', num);
    },

    onTradeinEstimationPriceInput(e) {
      const raw = (e && e.target ? e.target.value : e) ?? '';
      const digitsOnly = String(raw).replace(/[^\d]/g, '');
      const num = digitsOnly === '' ? null : Number(digitsOnly);
      this.emitUpdate('tradeinEstimationPrice', num);
      this.localForm.tradeinEstimationPrice = num;
    },

    syncInitialTab() {
      if (this.tradeinSummary) this.activeTab = 1;
      else if (this.targetSummary) this.activeTab = 0;
    },

    // ---------- Target search ----------
    async onSearchTargetProduct({ action, searchQuery, callback }) {
      if (action !== ASYNC_SEARCH) {
        callback();
        return;
      }
      await this.searchProducts(searchQuery, 'target');
      callback(null, this.targetProductOptions);
    },

    onSelectTargetProduct(selectedProduct) {
      if (!selectedProduct) return;
      this.emitUpdate('targetProductId', selectedProduct.id);
      this.emitUpdate('targetProductName', selectedProduct.name);
      this.emitUpdate('targetProduct', selectedProduct);

      const current = Number(
        this.localForm.targetQuotedPrice ?? this.form.targetQuotedPrice ?? 0,
      );
      if (!current) {
        this.emitUpdate(
          'targetQuotedPrice',
          selectedProduct.sellingPrice ?? null,
        );
      }
    },

    onTargetInput(v) {
      if (v) return;
      // cleared
      this.clearTarget();
    },

    clearTarget() {
      this.emitUpdate('targetProductId', null);
      this.emitUpdate('targetProductName', '');
      this.emitUpdate('targetQuotedPrice', null);
      this.emitUpdate('targetProduct', null);
    },

    // ---------- Trade-in search ----------
    async onSearchTradeinProduct({ action, searchQuery, callback }) {
      if (action !== ASYNC_SEARCH) {
        callback();
        return;
      }
      await this.searchProducts(searchQuery, 'tradein');
      callback(null, this.tradeinProductOptions);
    },

    onSelectTradeinProduct(selectedProduct) {
      if (!selectedProduct) return;
      this.emitUpdate('tradeinProductName', selectedProduct.name);
      this.emitUpdate('tradeinProduct', selectedProduct);

      // Persist helper metadata in tradeinAttributes (safe JSON blob)
      const attrs = {
        ...(this.localForm.tradeinAttributes ||
          this.form.tradeinAttributes ||
          {}),
      };
      attrs.tradeinProductId = selectedProduct.id;
      attrs.tradeinProductCode = selectedProduct.code;
      this.emitUpdate('tradeinAttributes', attrs);
    },

    onTradeinInput(v) {
      if (v) return;
      // treeselect cleared: keep whatever user typed in name; just clear helper attrs
      const attrs = {
        ...(this.localForm.tradeinAttributes ||
          this.form.tradeinAttributes ||
          {}),
      };
      delete attrs.tradeinProductId;
      delete attrs.tradeinProductCode;
      this.emitUpdate('tradeinAttributes', attrs);
    },

    clearTradein() {
      this.emitUpdate('tradeinProductName', '');
      this.emitUpdate('tradeinChassisNumber', '');
      this.emitUpdate('tradeinEngineNumber', '');
      this.emitUpdate('tradeinEstimationPrice', null);
      this.emitUpdate('tradeinProduct', null);

      const attrs = {
        ...(this.localForm.tradeinAttributes ||
          this.form.tradeinAttributes ||
          {}),
      };
      delete attrs.tradeinProductId;
      delete attrs.tradeinProductCode;
      attrs.images = [];
      this.emitUpdate('tradeinAttributes', attrs);
    },

    // ---------- Shared search ----------
    async searchProducts(searchQuery, kind) {
      const key =
        kind === 'tradein' ? 'tradeinProductOptions' : 'targetProductOptions';
      this[key] = [];
      if (!searchQuery || !String(searchQuery).trim()) return;
      try {
        const { data } = await productService.searchProducts({
          productName: searchQuery,
          limit: 10,
          isCheckStock: false,
        });
        const products = ProductModel.fromJsonArray(data?.data) || [];
        this[key] = products
          .filter((product) => {
            if (kind === 'tradein') {
              return product.type === ENUM.PRODUCT_TYPE_ENUM.CHASSIS_ENGINE;
            }
            return true;
          })
          .map((product) => this.mapProductToOption(product));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading products:', error);
      }
    },

    mapProductToOption(product) {
      const quantityInStock =
        product.productStock?.reduce(
          (sum, stock) => sum + (stock.quantity || 0),
          0,
        ) ??
        product.quantityInStock ??
        0;
      return {
        id: product.id,
        name: product.name,
        label: product.name || product.code || product.id,
        sellingPrice: product.sellingPrice,
        code: product.code,
        quantityInStock,
      };
    },

    removeImage(index) {
      const urls = this.imageUrls.slice();
      if (index < 0 || index >= urls.length) return;
      urls.splice(index, 1);
      const attrs = {
        ...(this.localForm.tradeinAttributes || {}),
        images: urls,
      };
      this.emitUpdate('tradeinAttributes', attrs);
    },

    async loadPreviewBlobUrls(paths) {
      const prev = this.previewBlobUrls || {};
      const currentSet = new Set(paths);
      Object.keys(prev).forEach((p) => {
        if (!currentSet.has(p)) {
          if (prev[p]) URL.revokeObjectURL(prev[p]);
          this.$delete(this.previewBlobUrls, p);
        }
      });
      const entityId = this.form?.id ?? null;
      for (const path of paths) {
        if (!path || path.startsWith('http')) continue;
        if (this.previewBlobUrls[path]) continue;
        try {
          const blobUrl = await PreorderService.fetchPreviewImage(
            path,
            entityId,
          );
          if (blobUrl) this.$set(this.previewBlobUrls, path, blobUrl);
        } catch (err) {
          console.error('Error loading preview image:', err);
        }
      }
    },
    getPreviewUrl(storedPath) {
      return this.previewBlobUrls[storedPath] || '';
    },
    openImageUrl(storedPath) {
      if (storedPath) window.open(this.getPreviewUrl(storedPath), '_blank');
    },

    // ---------- Upload images ----------
    async onFileChange(e) {
      const files = e.target.files;
      if (!files || !files.length) return;
      this.uploading = true;
      this.$emit('uploading-change', true);
      const currentImages = this.imageUrls.slice();
      try {
        for (let i = 0; i < files.length; i++) {
          const formData = new FormData();
          formData.append('file', files[i]);
          const res = await PreorderService.uploadImage(formData);
          const data = res?.data !== undefined ? res.data : res;
          const url =
            data?.url ??
            data?.data?.url ??
            data?.path ??
            data?.fileUrl ??
            data?.data?.imageUrl;
          if (url) currentImages.push(url);
        }
        const attrs = {
          ...(this.localForm.tradeinAttributes ||
            this.form?.tradeinAttributes ||
            {}),
          images: currentImages,
        };
        this.emitUpdate('tradeinAttributes', attrs);
      } catch (err) {
        this.$emit('upload-error', err);
      } finally {
        this.uploading = false;
        this.$emit('uploading-change', false);
        if (e.target) e.target.value = '';
      }
    },
  },
};
</script>

<style lang="scss">
.vue-treeselect__input-container {
  padding-top: 0px;
}

.vue-treeselect__control {
  border-radius: 0.28rem;
  border: 1px solid #ced4da;
  height: 2.5rem;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 2px;
}

.header-color {
  color: rgb(24, 28, 50);
}

table {
  td {
    vertical-align: middle !important;
  }
}
</style>

<style scoped>
.section-title {
  font-weight: 600;
  font-size: 1.2rem;
}

.image-gallery {
  gap: 1rem;
}

.image-preview-wrapper {
  width: 110px;
  height: 110px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.image-preview-wrapper:hover {
  transform: scale(1.02);
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.image-preview-placeholder {
  min-height: 110px;
  background-color: #f0f0f0;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.remove-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  padding: 0;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  z-index: 10;
}

.upload-trigger-box {
  width: 110px;
  height: 110px;
  border: 2px dashed #b5b5c3;
  border-radius: 8px;
  background-color: #f3f6f9;
  transition: all 0.2s ease-in-out;
}

.upload-trigger-box:hover {
  background-color: #e4e6ef;
  border-color: #3699ff;
  color: #3699ff !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
